/**
 * Landing page of the magic link (/auth/verify?token=…).
 *
 * The backend emails a link pointing at the app's own origin — the origin
 * the link was requested from, see `origin` in the magic-link request —
 * and this page hands the token straight to the backend verify endpoint,
 * which validates it and redirects back to /auth/callback?token=<jwt> on
 * this same origin. Mirrors memoneo's frontend/src/pages/AuthVerify.tsx.
 * Without this route the link landed on a blank SPA route (2026-09-19).
 */
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AUTH_BASE } from "../lib/api";
import { PageLayout, MutedText } from "../components/ui";

export default function AuthVerify() {
  const [params] = useSearchParams();
  const { t } = useTranslation();

  useEffect(() => {
    const token = params.get("token");
    if (token) {
      window.location.replace(`${AUTH_BASE}/verify?token=${encodeURIComponent(token)}`);
    }
  }, [params]);

  return (
    <PageLayout>
      <div className="flex items-center justify-center min-h-screen">
        <MutedText>{t("authFlow.signingIn")}</MutedText>
      </div>
    </PageLayout>
  );
}
